// extracted by mini-css-extract-plugin
module.exports = {"webex":"WorkspaceHome--webex--rjP1c","link":"WorkspaceHome--link--1X26d"};